import React, { FC } from 'react';
import { DatePicker as AntdDatePicker, DatePickerProps } from 'antd';
import BEMHelper from 'react-bem-helper';
import { moment } from '@utils/date';

import './styles.scss';

const classes = new BEMHelper({
  name: 'date-picker',
  outputIsString: true,
});

const DatePicker: FC<DatePickerProps> = ({
  value,
  onChange,
  className,
  format = 'LLL',
  ...otherProps
}) => {
  const handleOnChange = (value: moment.Moment | null, dateString: string) => {
    if (onChange) {
      // @ts-ignore
      onChange(value ? moment(value) : null, dateString);
    }
  };

  return (
    <AntdDatePicker
      {...otherProps}
      // @ts-ignore
      value={value ? moment(value) : null}
      onChange={handleOnChange}
      className={`${className} ${classes()}`}
      format={format}
    />
  );
};

export default DatePicker;
